import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IRaw837FileExport, IFileViewModel, IClaimAutomationElementsView } from './'
import { ODataService } from 'common-services'

export interface IClaimExportProcess extends IModelBase {
  TemplateId: number
  ClaimExportId: number
  ClaimIds: number[]
  FileViewModelDto: IFileViewModel
  ClaimExportTypeId: string
  ClaimExportConfigId: number
  ClaimTypeId: string
  PayerId: string
  NewExportId: number
  LastExportId: number
  NewExport: IRaw837FileExport
  LastExport: IRaw837FileExport
  Elements: IClaimAutomationElementsView[]
}

@Injectable()
export class ClaimExportProcessODataService extends ODataService<IClaimExportProcess> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimExportProcesses'
  }
}
